import { FC } from 'react'
import { Space, Tag } from 'antd'
import { translate } from '../../../core'
import { PurchaseOrder, PurchaseOrderCalculationReviewResponse } from '../type/purchase-order'

export const sourceTagMap: Record<PurchaseOrderCalculationReviewResponse['items'][number]['source'], {
  display: string,
  color: string
}> = {
  'BackOrder': {
    display: translate('back', 'order'),
    color: 'blue',
  },
  'CustomSku': {
    display: translate('stock', 'sku'),
    color: 'green',
  },
  'MinMax': {
    display: translate('min', 'max'),
    color: 'yellow',
  }
}

export type PurchaseOrderSourceTagProps = {
  value: PurchaseOrder['items'][number]['source']
  orderNumbers?: number[]
}

export const PurchaseOrderSourceTag: FC<PurchaseOrderSourceTagProps> = ({ value, orderNumbers }) => {
  const numbers = value === 'BackOrder'
    ? (orderNumbers ?? []).filter(Boolean)
    : []

  return (
    <Space direction='vertical' size={2}>
      {
        numbers.length
          ? numbers.map(number => (
            <Tag
              key={number}
              bordered={true}
              color={sourceTagMap[value].color as any}
              style={{ fontSize: 20 }}
              className='p-2'
            >
              {translate('back_order_abbr')} - {number}
            </Tag>
          ))
          : <Tag
            bordered={true}
            color={sourceTagMap[value].color as any}
            style={{ fontSize: 20 }}
            className='p-2'
          >
            {sourceTagMap[value].display}
          </Tag>
      }
    </Space>
  )
}
